import type { CanvasRecoveryState } from "./session-controller.js";
import { canvasCopy } from "../copy/zh-CN.js";

export function CanvasRecoveryNotice({ recovery, listingError, onExport, onRetry }: {
  recovery: CanvasRecoveryState;
  listingError?: string | undefined;
  onExport(): void;
  onRetry(): void;
}) {
  return (
    <>
    {listingError ? <aside className="studio-conflict" role="alert">{listingError}</aside> : null}
    {!recovery.durable || recovery.localError ? <aside className="studio-conflict" role="alert">
      <span>{!recovery.durable ? canvasCopy.unsavedWarning : canvasCopy.localStorageWarning}</span>
      <button type="button" onClick={onExport}>{canvasCopy.exportLocal}</button>
      {recovery.localError ? <button type="button" onClick={onRetry}>{canvasCopy.retrySave}</button> : null}
    </aside> : null}
    </>
  );
}
